import type { FC, PropsWithChildren } from 'react';
import { useEffect } from 'react';

import posthog from 'posthog-js';
import { PostHogProvider as PostHogProviderBase } from 'posthog-js/react';

import { useAuth } from 'shared/lib/auth/useAuth';

posthog.init(import.meta.env.VITE_APP_POSTHOG_API_KEY, {
  api_host: import.meta.env.VITE_APP_POSTHOG_HOST,
  defaults: '2025-05-24',
});

export const PostHogProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      posthog?.identify(user.id, {
        email: user.email,
      });
    }
  }, [user]);

  return <PostHogProviderBase client={posthog}>{children}</PostHogProviderBase>;
};
